<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
     viewBox="0 0 16 16">
  <path d="M14,5.333V14H2V5.333" fill="none" stroke="#5f8fb7" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.333"/>
  <path d="M.667,2H15.333V5.333H.667Z" fill="none" stroke="#5f8fb7"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/>
  <path d="M6.667,8H9.333" fill="none" stroke="#5f8fb7" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.333"/>
</svg>
